export default ({ parseGet }) => ({
  id: 'po-wo-based-customer',
  isAutoLoad: false,
  mode: {
    isModalNew: true,
    isModalEditing: true
  },
  store: {
    get: {
      url: 'RFQ2s/GetAllDynamic',
      selected: ['id', 'partID', 'part.partNumber as partNumber', 'rfqid', 'chosen', 'entryDate', 'supplierCompanyID',
        'supplierCompany.name as supplierCompanyName', 'partSN', 'price', 'currencyID', 'currency.title as currencyTitle',
        'price.toString()+currency.title as priceTitle', 'conditionID', 'condition.title as conditionTitle',
        'releaseID', 'release.title as releaseTitle', 'traceabilityCompanyID', 'traceabilityCompany.name as traceabilityCompanyName',
        'tagInfoCompanyID', 'tagInfoCompany.name as tagInfoCompanyName', 'tagDate', 'qty'
      ].join(','),
      filters: 'chosen=false && entryDate < DateTime.Now.AddMonths(-3)',
      parser: parseGet
    },
    create: {
      url: 'RFQ2s/Create'
    },
    patch: {
      // eslint-disable-next-line no-template-curly-in-string
      url: 'RFQ2s/Patch/${data.id}'
    },
    delete: {
      // eslint-disable-next-line no-template-curly-in-string
      url: 'RFQ2s/Delete/${data.id}',
      modal: {
        msgDataKey: 'partSN'
      }
    }
  },
  header: {
    isVisible: false
  },
  columns: [
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("chosen")}',
      template: 'boolean',
      field: 'custom_chosen',
      sortable: {
        isAvailable: false
      },
      editor: {
        type: 'checkbox',
        field: 'custom_chosen',
        customBehaviour: true
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("supplier")}',
      field: 'supplierCompanyName',
      sortable: {
        custom: 'supplierCompany.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("entry-date")}',
      field: 'entryDate',
      template: 'date'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("part-sn")}',
      field: 'partSN'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("price")}',
      field: 'price'
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("condition")}',
      field: 'conditionTitle',
      sortable: {
        custom: 'condition.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("release")}',
      field: 'releaseTitle',
      sortable: {
        custom: 'release.title'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("traceability")}',
      field: 'traceabilityCompanyName',
      sortable: {
        custom: 'traceabilityCompany.name'
      }
    },
    {
      // eslint-disable-next-line no-template-curly-in-string
      title: '${root.L10n("tag-info")}',
      field: 'tagInfoCompanyName',
      sortable: {
        custom: 'tagInfoCompany.name'
      }
    }
  ],
  toolbar: {
    filters: [
      {
        type: 'string',
        field: 'title',
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          valueTemplate: '( supplierCompany.name.contains("${data.value}") || part.partNumber.StartsWith("${data.value}") || partSN.contains("${data.value}") || condition.title.contains("${data.value}") )',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("search")}',
          styles: {
            minWidth: '15rem'
          }
        }
      },
      {
        type: 'selectautocomplete',
        field: 'supplierCompanyID',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("supplier")}',
        options: {
          dataSource: {
            url: 'Companies/GetAllDynamic',
            selected: 'id,name',
            take: 50
          },
          option: {
            label: 'name'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: "${root.L10n('all')}",
          styles: {
            minWidth: '25rem'
          }
        }
      },
      {
        type: 'selectautocomplete',
        field: 'partID',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("part")}',
        options: {
          // eslint-disable-next-line no-template-curly-in-string
          templateFilter: 'partNumber.StartsWith("${data.search}")',
          dataSource: {
            url: 'Parts/GetAllDynamic',
            selected: 'id,partNumber',
            take: 50
          },
          option: {
            label: 'partNumber'
          },
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("all")}',
          styles: {
            minWidth: '10rem'
          }
        }
      },
      {
        type: 'select',
        field: 'conditionID',
        // eslint-disable-next-line no-template-curly-in-string
        label: '${root.L10n("condition")}',
        options: {
          dataSource: 'Conditions/GetAllDynamic?select=id,title&orderBy=title asc',
          // eslint-disable-next-line no-template-curly-in-string
          placeholder: '${root.L10n("all")}',
          styles: {
            minWidth: '15rem'
          }
        }
      }
    ]
  }
})
